import { setGeneralInquiry } from 'lib/services/inquiry'
import { mapSelectionsToQuery } from 'lib/utils/filters'
import EventFilters from 'components/EventFilters'
import styles from './Filters.module.scss'

export default function Filters({ filters, callback }) {
  /**
   * Create new query object from selections.
   * Pass to callback.
   */
  const handleSelections = (data) => {
    // Persist selections to store.
    setGeneralInquiry(data)

    const newQuery = mapSelectionsToQuery(data, filters)

    callback(newQuery)
  }

  return (
    <section className={styles.section}>
      <div className="container">
        <EventFilters
          filters={filters}
          callback={handleSelections}
          design="secondary"
        />
      </div>
    </section>
  )
}
